import ReactSelect from 'react-select'
import classNames from 'classnames'
import { useField } from 'formik'
import React, { FC, ReactNode, useEffect, useState } from 'react'
import { styles as stylesV1 } from '@components/form/selects/select/styles'

import { LocationsApi, State } from '@services/api/locations'

import { FieldError } from '@components/form'
import { FieldProps } from '@components/form/types'

import styles from '../../styles.module.scss'
import { styles as stylesV2 } from '@components/form/selects/select/styles-v2'

interface Option {
  label: string
  value: any
}

interface Props extends FieldProps {
  onlyValue?: boolean
  label?: ReactNode
  className?: string
  stateId?: number
  disabled?: boolean
  placeholder?: string
  tabIndex?: number
  customStyle?: 'v1' | 'v2'
}

export const SelectState: FC<Props> = ({
  name,
  onlyValue = false,
  label,
  container: { className: containerClassName, ...container } = {},
  error,
  stateId,
  disabled,
  placeholder,
  tabIndex,
  customStyle = 'v1',
  ...props
}) => {
  const [states, setStates] = useState<Option[]>([])
  const [, meta, helpers] = useField(name)
  const [value, setValue] = useState<Option>()
  let componentMounted = true

  const converteStateForOptionSelect = (states: State[]) => {
    return states.map(state => {
      return {
        label: state.uf,
        value: state.id
      }
    })
  }

  useEffect(() => {
    LocationsApi.states().then(({ data }) => {
      const states = converteStateForOptionSelect(data.states)
      if (componentMounted) {
        setStates(states)
      }
    })

    return () => {
      componentMounted = false
    }
  }, [])

  useEffect(() => {
    if (componentMounted) {
      if (stateId) {
        setValue(states.find(state => state.value === stateId))
      } else {
        setValue(null)
      }
    }

    return () => {
      componentMounted = false
    }
  }, [stateId, states])

  return (
    <div
      className={classNames(styles.groupInput, containerClassName)}
      {...container}
    >
      {label}
      <ReactSelect
        id={name}
        instanceId={name}
        name={name}
        placeholder={placeholder || ''}
        options={states}
        value={value}
        onChange={optionSelected => {
          helpers.setValue(onlyValue ? optionSelected?.value : optionSelected)
          setValue(optionSelected)
        }}
        styles={customStyle === 'v1' ? stylesV1() : stylesV2()}
        isDisabled={disabled}
        tabIndex={tabIndex}
        menuShouldScrollIntoView={false}
        {...props}
      />
      <FieldError touched={meta.touched} error={meta.error} {...error} />
    </div>
  )
}
